/**
 * Create a codemirror state field  that counts the pages present in the document
 * @module pageCounter
 * @category CodeMirror
 */

import { type GutterState, pageNumbersGutterState } from "@quickpoint.me/shared/editor";

import { StateField } from "@codemirror/state";

export const pageCounter: StateField<number> = StateField.define({
  create() {
    return 1;
  },
  update(value, tr) {
    const selectedPos = tr.selection?.ranges[0].from;
    if (selectedPos === undefined) return value;
    const pages = tr.state.field(pageNumbersGutterState);
    let index = 1;
    if (Array.isArray(pages) && selectedPos) {
      pages.some((page: GutterState, idx) => {
        if (
          pages[idx + 1]
          && selectedPos >= page.line.from
          && selectedPos < pages[idx + 1].line.from
        ) {
          index = page.pageIdx;
          return true;
        }
        // if the last page is reached without a match select it.
        if (!pages[idx + 1]) {
          index = page.pageIdx;
        }
        return false;
      });
    }
    return index;
  },
});

export default pageCounter;
